// extracted by mini-css-extract-plugin
export default {"overlay":"iOazP6","openOverlay":"lCOr8Z","mounted":"CK5AEK"};